import { fromJS } from 'immutable';
import identity from 'lodash/identity';
import { createSelector } from 'reselect';

import * as utils from '../utils/duckHelpers';

export const types = {
    ...utils.requestTypes('FEATURED_SALES'),
    FEATURED_SALES_RESET: 'FEATURED_SALES_RESET',
    FEATURED_SALES_SET: 'FEATURED_SALES_SET',
    FEATURED_SALES_GET: 'FEATURED_SALES_GET',
};

export const actions = {
    featuredSalesSet: (obj) => utils.action(types.FEATURED_SALES_SET, obj),
};

const initialState = fromJS({
    loaded: 'loading',
});

export default (state = initialState, action) => {
    switch (action.type) {
    case types.FEATURED_SALES_SET:
        return fromJS({
            sales: action.payload.articles,
            total: action.payload.total,
            page: action.payload.page,
            loaded: 'complete',
        });
    case types.FEATURED_SALES_RESET:
        return initialState;
    default:
        return state;
    }
};

const getFeaturedSales = createSelector(
    identity,
    (state) => state.getIn(['app', 'featuredSales']),
);

export const selectors = {
    getFeaturedSales,
};
